<template>
  <router-link :to="`/profile/orders/${order.id}`">
    <div class="relative bg-gray-800 rounded-xl p-4 mt-4 text-sm text-white shadow-lg border-2 transition-all"
         @touchstart="toggleAnimation($event)" @touchend="toggleAnimation">
      <div class="grid grid-cols-2">
      <span class="flex">
        <OfficeBuildingIcon class="w-5 h-5 text-brand"/>
        <span class="mr-1">اتاق: {{ order.room.number }}</span>
      </span>
        <span class="flex items-center">
        <CashIcon class="h-5 w-5 text-brand"/>
        <span class="mr-1">{{ $helper.priceFormatter(order.total_price) }}</span>
      </span>
      </div>

      <div class="grid grid-cols-2 mt-3" v-if="true">
        <span class="flex">
          <CurrencyDollarIcon class="h-5 w-5 text-brand"/>
        <span class="mr-1" :class="statusClass(order.payment_status)">{{ status(order.payment_status) }}</span>
      </span>
        <span class="flex">
          <ClockIcon class="h-5 w-5 text-brand"/>
        <span class="mr-1">{{ order.created_at }}</span>
      </span>
      </div>

      <div class="mt-3">
        <table class="w-full text-xs text-gray-400">
          <tr v-for="item in order.items" :key="item.id" class="divide-y divide-gray-500">
            <td class="p-2">{{ item.product.name }}</td>
            <td>{{ item.count }} عدد</td>
            <td>{{ $helper.priceFormatter(item.price * item.count) }}</td>
            <td :class="statusClass(item.status)">{{ status(item.status) }}</td>
          </tr>
        </table>
      </div>
    </div>
  </router-link>
</template>

<script>
import {CashIcon, ClockIcon, CurrencyDollarIcon, OfficeBuildingIcon} from '@heroicons/vue/outline'

export default {
  name: "OrderCard",
  components: {
    OfficeBuildingIcon,
    ClockIcon,
    CashIcon,
    CurrencyDollarIcon
  },
  props: ['order'],
  data() {
    return {
      statusDialog: false,
      statusType: ''
    }
  },
  methods: {
    toggleAnimation(event) {
      event.currentTarget.classList.toggle('scale-95')
      event.currentTarget.classList.toggle('shadow-lg')
    },
    statusClass(status) {
      switch (status) {
        case 'pending':
          return 'text-yellow-300'
        case 'seen':
          return 'text-purple-300'
        case 'delivered':
        case 'paid':
          return 'text-green-300'
        case 'rejected':
        case 'canceled':
          return 'text-red-300'
      }
    },
    status(status) {
      switch (status) {
        case 'pending':
          return 'در انتظار'
        case 'seen':
          return 'دیده شده'
        case 'delivered':
          return 'تحویل شده'
        case 'rejected':
          return 'رد شده'
        case 'paid':
          return 'پرداخت شده'
        case 'canceled':
          return 'لغو شده'

      }
    },
  }
}
</script>

<style scoped>
</style>